export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'ccc82abe-3d8c-4aa7-8a0e-7b5d551ce2a7';
export const MODAL_CLOSE_SEC = 2.5;
